import React from 'react';

const SocialIcons = () => (
  <>
    <a
      className="socialicon no-style-links"
      href="https://www.linkedin.com/company/paragons-for-engineering-services"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="shine"></span>
      <i className="fa fa-linkedin"></i>
    </a>
  </>
);

export default SocialIcons;
